import {eqxAppConfigAuthMsal} from './eqxAuthMsal'
import eqxEventBroker from './eqxEventBroker'

abstract class eqxAuth {
    config: eqxAppConfigAuthMsal
    events: eqxEventBroker

    constructor(config: eqxAppConfigAuthMsal) {
        this.config = config
        this.events = new eqxEventBroker(this)
    }
    init() {}
    abstract isAuthenticated(): boolean
    abstract login(): Promise<any>
    abstract logout(): Promise<any>
    abstract getAccessToken(): Promise<string | null>
}
export default eqxAuth
